import React, { useState } from 'react'
import styles from './style.module.scss'
import icon from '@assets/images/hil/icon.svg'
import PropTypes from 'prop-types'
import CustomTable from '@shared/components/olympics/common/customTable'
import MyImage from '@shared/components/myImage'
import { getShortName } from '@shared/constants/utils'

export default function HilTable({ teamData }) {
  const [filter, setFilter] = useState('Men')

  const generateBodyData = gender => {
    return teamData
      ?.filter(ele => ele?.gender === gender)
      ?.map((ele, index) => {
        return [
          <div key={index} className="d-flex">
            <div className={styles.title}>
              <MyImage src={ele?.logo} height={24} width={24} />
            </div>
            {getShortName(ele?.teamName)}
          </div>,
          ele?.points?.matches || 0,
          ele?.points?.win || 0,
          ele?.points?.loss || 0,
          ele?.points?.draw || 0,
          ele?.points?.points || 0
        ]
      })
  }

  const bodyData = filter === 'Men' ? generateBodyData('male') : generateBodyData('female')

  const tableData = {
    header: ['Team', 'M', 'W', 'L', 'D', 'P'],
    body: bodyData
  }

  return (
    <>
      {/* <h3 className="small-head d-flex align-items-center  mb-3">
          <span>Standings</span>
        </h3> */}
      <div className={styles.leaguePointsTable}>
        <div className={`d-flex justify-content-between align-items-center ${styles.tableBanner}`}>
          <div>
            <MyImage className={styles.logo} src={icon} />
          </div>
          <div className={styles.tableCntr}>
            <div className={styles.filterContainer}>
              <button className={`${styles.filterButton} ${filter === 'Men' ? styles.activeFilter : ''}`} onClick={() => setFilter('Men')}>
                Men
              </button>
              <button
                className={`${styles.filterButton} ${filter === 'Women' ? styles.activeFilter : ''}`}
                onClick={() => setFilter('Women')}>
                Women
              </button>
            </div>
          </div>
        </div>
        <CustomTable
          table={tableData}
          noData={teamData?.length <= 0}
          smallTable
          isChess
          // slug={'https://globalchessleague.com/season_1/'}
        />
      </div>
    </>
  )
}

HilTable.propTypes = {
  teamData: PropTypes.array
}
